<template>
  <section data-testid="insights-perspective-buyer">
    <div class="grid grid-cols-1 gap-6 tablet:grid-cols-2 desktop:grid-cols-4" data-testid="insights-buyer-kpi-tiles">
      <InsightsKpiTile
        :loading="loading"
        :state="kpi.states.clickout"
        :label="t('Reviews.product.insights.buyer.profileViews.label')"
        :value="kpi.profileViews.value"
        :delta="kpi.profileViews.trend"
        :caption="windowCaption(kpi.profileViews.caption)"
        data-testid="insights-buyer-tile-profile-views"
      />
      <InsightsKpiTile
        :loading="loading"
        :state="kpi.states.clickout"
        :label="t('Reviews.product.insights.buyer.clickOuts.label')"
        :value="kpi.clickOuts.value"
        :delta="kpi.clickOuts.trend"
        :caption="windowCaption(kpi.clickOuts.caption)"
        data-testid="insights-buyer-tile-click-outs"
      />
      <InsightsKpiTile
        coming-soon
        :label="t('Reviews.product.insights.buyer.dwellTime.label')"
        :caption="t('Reviews.product.insights.buyer.dwellTime.comingSoon')"
        data-testid="insights-buyer-dwell-time-tile"
      />
      <InsightsKpiTile
        :loading="loading"
        :state="kpi.states.visiting"
        :label="t('Reviews.product.insights.buyer.visitingCompanies.label')"
        :value="kpi.visitingCompanies"
        :caption="t('Reviews.product.insights.buyer.visitingCompanies.caption')"
        data-testid="insights-buyer-tile-visiting-companies"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import type { BuyerInsightsView, CompetitionVisibilityCaption } from '@/gql/reviews/mappers/insights'

const { t } = useI18n()

withDefaults(defineProps<{ kpi: BuyerInsightsView; loading?: boolean }>(), { loading: false })

const windowCaption = ({ span, compared, params }: CompetitionVisibilityCaption) =>
  t(`Reviews.product.insights.buyer.windowCaption.${span}${compared ? '' : 'NoComparison'}`, params)
</script>
